import Nullstack from 'nullstack';
export default function IconBuildingFortress({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-fortress",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
  }), "   ", Nullstack.element("path", {
    d: "M7 7h0v.01"
  }), "   ", Nullstack.element("path", {
    d: "M7 10h0v.01"
  }), "   ", Nullstack.element("path", {
    d: "M7 13h0v.01"
  }), "   ", Nullstack.element("path", {
    d: "M17 7h0v.01"
  }), "   ", Nullstack.element("path", {
    d: "M17 10h0v.01"
  }), "   ", Nullstack.element("path", {
    d: "M17 13h0v.01"
  }), " ");
}